"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyMessageSignature = exports.getCoreMessageFromFullMessage = exports.getSignedMessageWithSigner = void 0;
const viem_1 = require("viem");
const chains_1 = require("viem/chains");
const MagicDivider = '\n---------\n';
const { version } = require('../package.json');
function createMessage(account) {
    return {
        account: account,
        nonce: new Date().getTime() + getRandomInt(-1000, 1000),
        timestamp: new Date().getTime(),
        version: version
    };
}
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}
/**
 * Get message and signature with a web3 signer, such as metamask signer, used for client-to-server verification.
 */
async function getSignedMessageWithSigner(account, signer, humanMessage = '') {
    if (!humanMessage) {
        humanMessage = 'Welcome to Storyverse!\n\nClick sign to authorize your wallet.\n\nThis request will not trigger a blockchain transaction or cost any gas fees.\n';
    }
    const message = createMessage(account);
    const fullMessage = humanMessage + MagicDivider + JSON.stringify(message);
    let signature = await signer.signMessage?.({
        account,
        message: fullMessage,
    });
    return {
        message: fullMessage,
        signature: signature
    };
}
exports.getSignedMessageWithSigner = getSignedMessageWithSigner;
/**
 * Get message and signature with a private key, used for server-to-server verification.
 */
// the following was used by the discord creator bot, no need to port to viem for now
// export async function getSignedMessageWithPrivateKey(account: string, privateKey: string) {
//   const message = createMessage(account);
//   const humanMessage = 'This is auto-generated message for server to server communication.'
//   const fullMessage: string = humanMessage + MagicDivider + JSON.stringify(message);
//   const provider = new ethers.providers.AlchemyProvider();
//   const signer = new ethers.Wallet(privateKey, provider);
//   const signature = await signer.signMessage(fullMessage);
//   return {
//       message: fullMessage,
//       signature: signature
//   }
// }
function getCoreMessageFromFullMessage(fullMessage) {
    const indexOfMagicDivider = fullMessage.indexOf(MagicDivider);
    const indexOfJson = indexOfMagicDivider + MagicDivider.length;
    const jsonMessage = JSON.parse(fullMessage.substring(indexOfJson));
    return jsonMessage;
}
exports.getCoreMessageFromFullMessage = getCoreMessageFromFullMessage;
const publicClient = (0, viem_1.createPublicClient)({
    chain: chains_1.mainnet,
    transport: (0, viem_1.http)()
});
/**
 * Verify message and signature, returns core message on success.
 * @returns {TMessageForSigning}
 */
async function verifyMessageSignature(fullMessage, signature) {
    const jsonMessage = getCoreMessageFromFullMessage(fullMessage);
    const typedSig = signature;
    const valid = await publicClient.verifyMessage({
        address: jsonMessage.account,
        message: fullMessage,
        signature: typedSig,
    });
    if (!valid) {
        throw `accountFromMessage not equal to accountFromSignatureVerification:: message: ${fullMessage} sig: ${signature}`;
    }
    return jsonMessage;
}
exports.verifyMessageSignature = verifyMessageSignature;
